import services from 'services/module';

export class LocalStorageSvc {
    isSupported = false;
    storage: Storage;

    constructor(private $window: Window,
                private $log: ng.ILogService) {

        try {
            let supported: boolean = $window && $window.localStorage !== null;
            const key = '__' + Math.round(Math.random() * 1e7);
            if (supported) {
                this.storage = $window.localStorage;
                this.storage.setItem(key, 'value');
                supported = this.storage.getItem(key) === 'value';
                this.storage.removeItem(key);
            }
            this.isSupported = supported;
        } catch (e) {
            $log.warn('LocalStorage is disabled');
            this.isSupported = false;
        }
    }

    set<T>(key: string, value: T): void {
        if (this.isSupported) {
            this.storage.setItem(key, JSON.stringify(value));
        } else {
            this.$log.debug('Cannot set ' + key + ' to localStorage');
        }
    };

    get<T>(key: string): T | null {
        const onError = (): null => {
            this.$log.debug('Cannot get ' + key + ' from localStorage');
            return null;
        };
        if (this.isSupported) {
            return this.safeOperation(() =>
                JSON.parse(this.storage.getItem(key)), onError);
        } else {
            return onError();
        }
    };

    remove<T>(key: string): T | null {
        if (this.isSupported) {
            const value = this.get<T>(key);
            this.storage.removeItem(key);
            return value;
        } else {
            this.$log.debug('Cannot remove ' + key + ' from localStorage');
            return null;
        }
    };

    private safeOperation<T>(unsafeFunc: () => T, onError: () => null): T | null {
        try {
            return unsafeFunc();
        } catch (e) {
            return onError();
        }
    };
}

services.service('LocalStorageSvc', LocalStorageSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/LocalStorageSvc.ts